/**
 * PermissionTitle Component
 * Displays the title based on permission state
 */

import React from 'react'
import { Typography } from '@mui/material'
import { INTERAX_COLORS } from '../../../../constants/colors'
import { useTranslation } from '../../../../shared/hooks/useIntractionTranslate'
import { PermissionState } from '../../helpers/permissionHelpers'

interface PermissionTitleProps {
  permissionState: PermissionState
  hasError: boolean
}

export const PermissionTitle: React.FC<PermissionTitleProps> = ({ permissionState, hasError }) => {
  const { t } = useTranslation()
  const isDenied = permissionState === 'denied'

  return (
    <Typography
      sx={{
        color: INTERAX_COLORS.white,
        fontSize: '24px',
        fontWeight: 600,
        textAlign: 'center'
      }}
    >
      {isDenied
        ? t('gamer.permissionScreen.title.denied')
        : hasError
          ? t('gamer.permissionScreen.title.error')
          : t('gamer.permissionScreen.title.prompt')}
    </Typography>
  )
}
